// extracted by mini-css-extract-plugin
var _1 = "UserDetailPreview-module__actionButton--c6hwB";
var _2 = "UserDetailPreview-module__amount--fDRwJ";
var _3 = "UserDetailPreview-module__animateUploadProgressBarWidth--WkZlZ";
var _4 = "UserDetailPreview-module__animatedBackground--tm_KF";
var _5 = "UserDetailPreview-module__avatar--PufuD";
var _6 = "UserDetailPreview-module__content--DOxh7";
var _7 = "UserDetailPreview-module__editorRoot--hRwUS";
var _8 = "UserDetailPreview-module__footer--z3Rd3";
var _9 = "UserDetailPreview-module__groupIcon--myKJ2";
var _a = "UserDetailPreview-module__groups--iVVaD";
var _b = "UserDetailPreview-module__header--QU80d";
var _c = "UserDetailPreview-module__headerSection--yzNkm";
var _d = "UserDetailPreview-module__identity--GFJjj";
var _e = "UserDetailPreview-module__overlayLink--_jnkS";
var _f = "UserDetailPreview-module__posts--BkwsN";
var _10 = "UserDetailPreview-module__postsIcon--c3z5Q";
var _11 = "UserDetailPreview-module__profiles--1x7dw";
var _12 = "UserDetailPreview-module__title--ueWIH";
var _13 = "UserDetailPreview-module__topics--vOSjl";
var _14 = "UserDetailPreview-module__topicsIcon--jEWL1";
var _15 = "UserDetailPreview-module__userBadge--yfNmi";
export { _1 as "actionButton", _2 as "amount", _3 as "animateUploadProgressBarWidth", _4 as "animatedBackground", _5 as "avatar", _6 as "content", _7 as "editorRoot", _8 as "footer", _9 as "groupIcon", _a as "groups", _b as "header", _c as "headerSection", _d as "identity", _e as "overlayLink", _f as "posts", _10 as "postsIcon", _11 as "profiles", _12 as "title", _13 as "topics", _14 as "topicsIcon", _15 as "userBadge" }
